import { Card, Chip, Money } from '../../ui/parts'
import type { EarnAction } from '../types'

/** "2d 04h left", "3h 12m left", "48s left" — coarse when far off, precise when close. */
export function countdown(msRemaining: number): string {
  if (msRemaining <= 0) return 'Expired'
  const totalSeconds = Math.floor(msRemaining / 1000)
  const days = Math.floor(totalSeconds / 86_400)
  const hours = Math.floor((totalSeconds % 86_400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  if (days > 0) return `${days}d ${hours}h left`
  if (hours > 0) return `${hours}h ${minutes}m left`
  if (minutes > 0) return `${minutes}m ${seconds}s left`
  return `${seconds}s left`
}

export function EarnActionCard({
  action,
  onComplete,
}: {
  action: EarnAction
  onComplete: () => void
}) {
  const remaining = action.expiresAt ? new Date(action.expiresAt).getTime() - Date.now() : null
  const urgent = remaining !== null && remaining < 6 * 3600 * 1000

  return (
    <Card tight>
      <div className="row" style={{ alignItems: 'flex-start' }}>
        <div className="grow">
          <div style={{ fontWeight: 620 }}>{action.title}</div>
          {action.description ? (
            <div className="muted" style={{ fontSize: 13, marginTop: 2 }}>
              {action.description}
            </div>
          ) : null}
        </div>
        <div style={{ textAlign: 'right' }}>
          <div className="label">Reward</div>
          <div style={{ fontWeight: 700 }}>
            <Money fils={action.rewardFils} signed />
          </div>
        </div>
      </div>

      <div className="row between" style={{ marginTop: 12 }}>
        <div>
          <Chip tone={remaining === null ? 'mint' : urgent ? 'coral' : 'amber'}>
            {remaining === null ? 'Repeatable' : countdown(remaining)}
          </Chip>
          <div className="muted" style={{ fontSize: 11, marginTop: 3 }}>
            {action.expiresAt
              ? `Expires ${new Date(action.expiresAt).toLocaleString('en-GB', {
                  day: 'numeric',
                  month: 'short',
                  hour: '2-digit',
                  minute: '2-digit',
                })}`
              : action.completedCount > 0
                ? `Never expires · completed ${action.completedCount}×`
                : 'Never expires'}
          </div>
        </div>
        <button type="button" className="btn mint small" onClick={onComplete}>
          Complete
        </button>
      </div>
    </Card>
  )
}
